<template>
  <div id="objectstorage">
    <div
      v-show="!dialog"
      class="close-button"
      :class="{ close: !leftClose }"
      @click="leftClose = !leftClose"
    >
      <i :class="leftClose ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"></i>
    </div>
    <div class="left-box" :class="{ close: !leftClose }">
      <div class="button-group" style="margin:0;">
        <div class="name">Bucket列表</div>
        <el-button type="text" size="small" @click="newObject">
          <i class="el-icon-ga-tianjiashipinhechupintujiahao"></i>
        </el-button>
      </div>
      <div class="button-group">
        <el-input
          size="small"
          placeholder="bucket名称"
          v-model="filterValue"
          class="filter-input"
          @keyup.enter.native="onSubmit"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="onSubmit"
          ></el-button>
        </el-input>
      </div>
      <el-table
        v-loading="loading"
        :show-header="false"
        border
        :data="tableData[listPage]"
        height="calc(100% - 96px - var(--padding) * 2"
        highlight-current-row
        @row-click="newTabs"
      >
        <el-table-column label="对象名称" prop="name" min-width="100">
          <template slot-scope="scope">
            <span class="path">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
      </el-table>
      <page-trun
        style="padding: 0 var(--padding) var(--padding);justify-content: center;"
        :page="{ pageIndex: listPage + 1, hasMore: false }"
        :queryData="tableData"
        @pageTrun="listTrun"
      ></page-trun>
    </div>
    <bucket
      v-if="editableTabs.title"
      :bucket="editableTabs.object"
      @deleteBu="deleteObject"
    />
    <object-dialog :dialog.sync="dialog" @refush="refush" />
  </div>
</template>

<script>
import objectDialog from "./dialog.vue";
import eltab from "@/mixin/eltab.js";
import { Delete, paging } from "@/utils/index";
import bucket from "./bucket.vue";

export default {
  name: "objectstorage",
  data() {
    return {
      leftClose: true,
      filterValue: "",
      dialog: false,
      loading: false,
      tableData: [],
      editableTabs: {},
      oldData: [],
      listPage: 0
    };
  },
  computed: {
    userGroup() {
      return this.$store.state.userGroup;
    }
  },
  mounted() {
    this.getData();
  },
  mixins: [eltab],
  methods: {
    onSubmit() {
      let reg = new RegExp(this.filterValue);
      this.tableData = paging(this.oldData.filter(item => reg.test(item.name)));
      this.listPage = 0;
    },
    getData() {
      this.loading = true;
      this.$http
        .get("/gavial/v1/mos/bucket")
        .then(res => {
          this.oldData = res.data.data;
          this.tableData = paging(this.oldData);
          this.listPage = 0;
          // this.newTabs(this.tableData[0]);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    listTrun(pageIndex) {
      this.listPage = pageIndex - 1;
    },
    newObject() {
      this.dialog = true;
    },
    deleteObject(row = this.editableTabs.object) {
      Delete(
        `/gavial/v1/mos/bucket?bucket=${row.name}`,
        row.name,
        () => {
          this.editableTabs = {};
          this.refush();
        },
        bool => {
          this.loading = bool;
        }
      );
    },
    newTabs(row) {
      if (row.name === this.editableTabs.title) return false;
      this.editableTabs = {
        title: row.name,
        object: row
      };
    },
    refush() {
      this.filterValue = "";
      this.getData();
    }
  },
  components: {
    objectDialog,
    bucket
  }
};
</script>

<style lang="scss" scoped>
#objectstorage {
  height: 100%;
  position: relative;
  display: flex;
  .close-button {
    position: absolute;
    background: #f0f2f5;
    top: calc((100% - 32px - var(--padding)) / 2);
    left: 225px;
    z-index: 1;
    height: 40px;
    line-height: 40px;
    width: 15px;
    cursor: pointer;
    &.close {
      left: 0;
    }
  }
  .left-box {
    flex: 0 0 240px;
    margin-right: var(--padding);
    overflow: hidden;
    &.close {
      display: none;
      overflow: hidden;
    }
    .button-group {
      .name {
        flex: 1 1 auto;
        line-height: 32px;
      }
      .filter-input {
        width: 240px;
      }
      & > .el-button {
        padding: 0px 7px;
        min-width: 0px;
        font-size: 17px;
        line-height: 32px;
        margin: 0;
      }
    }
  }
  .content {
    height: 100%;
    flex: 1 1 auto;
  }
}
</style>
